import { X } from "lucide-react";
import { cn } from "@/lib/utils";

export function FilterPill({ active, className, children, ...props }) {
  return (
    <button
      type="button"
      aria-pressed={active}
      className={cn(
        "min-h-9 rounded-full border px-3.5 py-1.5 text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        active
          ? "border-primary bg-primary text-primary-foreground"
          : "border-border bg-card text-foreground hover:border-primary/50 hover:bg-accent",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}

// সাইডবার (ডেস্কটপ) আর নিচ থেকে ওঠা শিট (মোবাইল) — দুই জায়গায় একই গ্রুপ
export function FilterGroups({ taxonomies, filters, onToggle }) {
  return (
    <div className="space-y-6">
      {taxonomies.map((x) => (
        <fieldset key={x.key}>
          <legend className="mb-2.5 text-sm font-semibold text-foreground">{x.label_bn}</legend>
          <div className="flex flex-wrap gap-2">
            {x.terms.map((m) => (
              <FilterPill key={m.value} active={filters[x.key] === m.value} onClick={() => onToggle(x.key, m.value)}>
                {m.label_bn}
              </FilterPill>
            ))}
          </div>
        </fieldset>
      ))}
    </div>
  );
}

// কী কী ফিল্টার চলছে — সবসময় চোখের সামনে, এক ট্যাপে সরানো যায়, আর "সব মুছুন"
export function AppliedFilters({ chips, onClear, className }) {
  if (chips.length === 0) return null;
  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)} aria-label="চালু ফিল্টার">
      {chips.map((c) => (
        <button
          key={c.id}
          type="button"
          onClick={c.onRemove}
          aria-label={`${c.label} — সরান`}
          className="inline-flex min-h-8 items-center gap-1.5 rounded-full bg-accent py-1 pl-3 pr-2 text-sm text-accent-foreground transition-colors hover:bg-accent/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {c.label}
          <X className="h-3.5 w-3.5 opacity-70" aria-hidden="true" />
        </button>
      ))}
      {chips.length > 1 && (
        <button
          type="button"
          onClick={onClear}
          className="rounded-md px-2 py-1 text-sm text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          সব মুছুন
        </button>
      )}
    </div>
  );
}
